/**
 * @packageDocumentation
 * @module f1/string
 */

export interface Capitalize {
  /**
   * Capitalize the first letter of a string
   *
   * @public
   * @function f1.capitalize
   * @param s a human language string
   * @example
   *
   * ```ts
   * capitalize('mike') === 'Mike'
   * capitalize('mike jaworski') === 'Mike jaworski'
   * ```
   */
  (s: string): string;
}

/**
 * @see Capitalize
 */
export default (s: string) => {
  return s.slice(0, 1).toUpperCase() + s.slice(1);
};
